















































import Vue, { PropOptions } from 'vue'
import Loader from './Loader.vue'

export default Vue.extend({
	name: 'Search',
	props: {
		id: {
			type: String,
			required: true
		} as PropOptions<string>,
		placeholder: {
			type: String,
			required: false
		} as PropOptions<string>,
		query: {
			type: String,
			required: true
		} as PropOptions<string>,
		minQueryLength: {
			type: Number,
			required: true,
			default: 1
		} as PropOptions<number>,
		results: {
			type: Array,
			required: true,
			default: () => []
		} as PropOptions<any[]>,
		loading: {
			type: Boolean,
			default: false
		} as PropOptions<boolean>,
		focusOnMount: {
			type: Boolean,
			default: false
		} as PropOptions<boolean>,
		isSelectedQuery: {
			type: Boolean,
			default: false
		} as PropOptions<boolean>
	},
	data: () => ({
		activedescendant: -1,
		searchResultsOpen: false
	}),
	components: {
		Loader
	},
	computed: {
		modelQuery: {
			get(): string {
				return this.query
			},
			set(value: string): void {
				this.$emit('input', value)
			}
		}
	},
	watch: {
		'query.length'(newVal: number): void {
			if (!this.isSelectedQuery) {
				this.searchResultsOpen = newVal >= this.minQueryLength
			}
		}
	},
	mounted(): void {
		if (this.focusOnMount) {
			(this.$refs.searchInput as HTMLInputElement).focus()
		}
	},
	methods: {
		setActiveDescendant(val: number, e: KeyboardEvent): void {
			e.preventDefault()

			const { activedescendant, results } = this
			let newValue

			if (val === 0) {
				newValue = val
			} else if (val === -1 && activedescendant === 0) {
				newValue = results.length - 1
			} else {
				newValue = Math.abs((activedescendant + val) % results.length)
			}

			this.activedescendant = newValue
			const resultListItem = this.$refs.resultsListItem as HTMLElement[]

			if (!resultListItem[this.activedescendant]) {
				return
			}
			resultListItem[this.activedescendant].focus()
		},
		selectItem(item: Record<string, any>): void {
			this.$emit('selectItem', item)
			this.searchResultsOpen = false
		},
		handleFocus(): void {
			if (this.query.length >= this.minQueryLength) {
				this.searchResultsOpen = true
			}
		}
	}
})
